import { createQueryKeys } from "@lukemorales/query-key-factory";

import { getInsurancesList, GetInsurancesListParams } from "./api";

export const queries = createQueryKeys("insurances", {
  list: ({ stateId, eligibility }: GetInsurancesListParams) => {
    return {
      queryKey: ["insurances", stateId, eligibility],
      queryFn: () => getInsurancesList({ stateId, eligibility }),
    };
  },
});
